<template>
    <b-row no-gutters
           id="futurocoin_from_mining_component"
           class="futurocoin-from-mining-component">
        <b-col lg="8" class="futurocoin-from-mining-inner">
            <div class="futurocoin-from-mining-banner">
                <span v-if="amount !== '-'">
                    Your FuturoCoins from mining: {{ amount }} FTO
                </span>
                <span v-else>
                    FTO are being counted
                     <div class="data-loader__inline"></div>
                </span>
            </div>
        </b-col>
        <!--header-payout v-if="!hidePayout && !transferHistory"></header-payout-->
        <header-button v-if="hidePayout"
                       :button-label="buttonLabel"
                       :button-link="buttonLink"></header-button>
    </b-row>
</template>

<script>
    import HeaderPayout from '../../../header/bottombar/HeaderPayout.vue'
    import HeaderButton from '../../../header/bottombar/HeaderButton.vue'
    export default {
        components: { HeaderButton, HeaderPayout },
        dependencies: ['ftoAccounts', 'money'],
        props: ['hidePayout', 'buttonLabel', 'buttonLink', 'transferHistory'],
        data () {
            return {
                reload: ''
            }
        },
        computed: {
            amount () {
                return this.money.format(this.$store.getters.ftoAccounts.miningAccount, 'fto')
            }
        },
        beforeCreate () {
            let _this = this
            _this.ftoAccounts.fetchData()
            this.reload = setInterval(_this.ftoAccounts.fetchData, 60000)
        },
        beforeDestroy () {
            clearInterval(this.reload)
        }
    }
</script>

<style lang="scss">
    @import '../../../../../../assets/scss/_colors.scss';

    .futurocoin-from-mining-component{
        height: 95px;
        border-bottom: 1px solid $base1;
        margin-bottom: 30px;
    }

    .futurocoin-from-mining-inner{
        position: relative;
    }

    .futurocoin-from-mining-banner{
        display: flex;
        align-items: center;
        height: 60px;
        background-color: $op;
        padding: 0 0 0 62px;
        color: $white !important;
        font-size: 18px;
        font-weight: bold;
        line-height: normal;
        background-image: url('../../../../../../assets/img/futurocoin.png');
        background-size: 30px;
        background-repeat: no-repeat;
        background-position: 20px center;
        transition: 200ms all linear;

        >span{
            display: flex;
            align-items: center;
        }
    }

    @media(min-width: 992px){
        .futurocoin-from-mining-inner{
            padding-right: 10px !important;
        }
    }

    @media(max-width: 991px){
        .futurocoin-from-mining-inner{
            width: 100%;
        }

        .futurocoin-from-mining-banner{
            height: 57px;
            display: flex;
            align-items: center;
            padding: 10px 0 11px 70px;
            font-size: 16px;
        }
    }

    @media(max-width: 359px){
        .futurocoin-from-mining-banner{
            padding-left: 11px;
            background-image: none;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/dashboard/FuturocoinsFromMining.vue